export const googleSheetsEmailScriptUrl = `https://script.google.com/macros/s/AKfycbzYtEjJowoIROdk-GxZBt5250n2x3lwLhUrQRGmNbSodGM4-CVn/exec`;
export const defaultNumSuggestionsShown = 3;
export const additionalSuggestionsShown = 3;
export const getStartedTemplateId = 'f3f5f3a1-6a58-44a7-88a0-a15d9e3ca94c';
export const fields = [
  { fieldId: '#subject-text-field', ancestor: 'subject' },
  { fieldId: '#body-text-field', ancestor: 'body' }
]